import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import { googleAuthServiceFactory } from "../../services/GoogleAuthServiceImpl";
import { ResponseMessage } from "../../domain/enums/common/ResponseMessageEnum";
import { userServiceFactory } from "../../services/UserServiceImpl";
import { User } from "../../domain/models/User";

interface GoogleLoginButtonProps {
    onSuccess: (curentUser: User) => void;
    onError?: (error: string) => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess, onError }) => {
    const { t } = useTranslation();

    const handleSuccess = async (credentialResponse: CredentialResponse) => {
        try {
            const response = await googleAuthServiceFactory().loginWithGoogle(credentialResponse.credential);

            if (response === ResponseMessage.SUCCESS && onSuccess) {
                onSuccess(await userServiceFactory().getCurrentUser());
            } else {
                if (onError) onError(t("errors.common"));
            }
        } catch (err: any) {
            if (onError) onError(t("errors.common"));
        }
    };

    return <GoogleLogin onSuccess={handleSuccess} onError={() => onError && onError(t("errors.common"))} />;
};

export default GoogleLoginButton;
